import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-c06a6a66")
const _hoisted_1 = {
  key: 0,
  class: "p-d-flex p-jc-between margin-head"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "h1" }, "Empresas", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.currentRoute === 'CompaniesList')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_Button, {
            class: "company-btn",
            type: "button",
            icon: "pi pi-plus",
            label: "Crear Empresa",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({name: _ctx.JobBankRouteNames.CREATE_COMPANY})))
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ]))
}